export default {
  toolbar: {
    minHeight: '38px',
  },
  selectIcon: {
    top: '5px',
  }
}